import { useState, useContext } from 'react'
import { ArrowLeft } from 'lucide-react'
import InformacionDocumento from './InformacionDocumento'
import ConfiguracionProgramacion from './ConfiguracionProgramacion'
import { FacturaAPI } from '../../../../../../../../api/facturas.api'
import GlobalContext from '../../../../../../../../context/global-context'
import { buildScheduledFacturaPayload } from './utils/scheduledFacturaPayload'
import { sileo } from 'sileo'

export default function NuevoProgramado({ onBack, isModal = false }) {
  const api = new FacturaAPI()
  const [, setReceiverEntityId] = useState(null)
  const { currentBusiness, masterEntityData } = useContext(GlobalContext)
  const masterEntityId = masterEntityData?.id
  const [formState, setFormState] = useState({
    client: null,
    documentType: '33',
    currency: 'CLP',
    details: [
      {
        id: Date.now(),
        item_type_code: '',
        item_code: '',
        item_name: '',
        showDescription: false,
        quantity: 1,
        unit_price: 0,
        discount_percent: 0,
        item_description: ''
      }
    ],
    references: [],
    showReferencesBox: false,
    config: {
      frequency: 'monthly', // ✅ ahora valores del contrato
      start_date: new Date().toISOString().split('T')[0], // ✅ (YYYY-MM-DD) pre-fill with today
      day_of_month: 1, // ✅ number
      day_of_week: 'monday', // UI string, luego lo convertimos a 0..6
      emission_day_adjustment: 'none', // ✅ none | next | previous
      end_type: 'never', // ✅ never | on_date | after_occurrences
      end_date: '', // ✅ requerido si end_type === 'on_date'
      max_occurrences: null,
      currency_day: new Date().getDate()
    }
  })

  // State to track simple validation errors
  const [errors, setErrors] = useState({})

  // master_entity_id (sender) now comes from GlobalContext

  const handleSave = async () => {
    // Validación mínima para que el back no rechace por DTO
    const newErrors = {}

    if (!formState.client?.id) {
      newErrors.client = 'Selecciona un cliente válido para continuar'
    }

    // details: min 1 y item_name obligatorio
    const details = formState.details || []
    if (details.length === 0) {
      newErrors.details = 'Debes agregar al menos una línea de detalle'
    } else {
      const hasEmptyName = details.some(d => !String(d.item_name || '').trim())
      if (hasEmptyName) newErrors.details = 'Cada detalle debe tener nombre de producto'
    }
    // ✅ Validación mínima según end_type
    const endType = formState.config.end_type
    if (endType === 'on_date' && !formState.config.end_date) {
      newErrors.end_date = 'Debes seleccionar una fecha fin'
    }
    if (endType === 'after_occurrences') {
      const occ = Number(formState.config.max_occurrences)
      if (!Number.isFinite(occ) || occ < 1) {
        newErrors.max_occurrences = 'Debes indicar un número de emisiones mayor o igual a 1'
      }
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      return
    }

    // ✅ Payload DTO
    const payload = buildScheduledFacturaPayload(formState, masterEntityId)

    try {
      await api.crearDocumentosProgramados(currentBusiness.id, masterEntityId, payload)
      sileo.success({
        title: 'Programación Exitosa',
        description: (
          <span className='text-green-500/80 font-medium'>
            Programación creada exitosamente... 👌
          </span>
        )
      })
      onBack()
    } catch (error) {
      console.error('Error creating schedule:', error)
      sileo.error({
        title: 'Error de Programación',
        description: (
          <span className='text-red-500/80 font-medium'>
            {'Error al crear la programación 🤯' + JSON.stringify(error.response.data.message)}
          </span>
        )
      })
    }
  }

  const clearError = field => {
    setErrors(prev => {
      const newErrors = { ...prev }
      delete newErrors[field]
      return newErrors
    })
  }

  return (
    <div>
      {!isModal && (
        <button
          onClick={onBack}
          className='flex items-center gap-2 text-gray-700 hover:text-gray-900 mb-4'
        >
          <ArrowLeft size={18} />
          Volver
        </button>
      )}
      <div className='grid grid-cols-1 lg:grid-cols-3 gap-6'>
        {/* Left Column: Document Information (2/3 width) */}
        <div className='lg:col-span-2'>
          <InformacionDocumento
            setMasterEntityId={setReceiverEntityId}
            formState={formState}
            setFormState={setFormState}
            errors={errors}
            clearError={clearError}
          />
        </div>

        {/* Right Column: Programming Config (1/3 width) */}
        <div className='lg:col-span-1'>
          <ConfiguracionProgramacion
            formState={formState}
            setFormState={setFormState}
            handleSave={handleSave}
          />
        </div>
      </div>
      <style>{`
          .section-title {
             display: flex;
             align-items: center;
             gap: 0.75rem;
             font-size: 1.1rem;
             font-weight: 600;
             color: #1e293b;
             margin-bottom: 1.5rem;
             padding-bottom: 0.75rem;
             border-bottom: 1px solid #f1f5f9;
          }

          .section-number {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 28px;
            height: 28px;
            background: #f8fafc;
            border: 1px solid #e2e8f0;
            border-radius: 8px;
            font-size: 0.85rem;
            color: #64748b;
          }
        `}</style>
    </div>
  )
}
